import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';

export default function setTopBar() {
  const topBar = document.querySelector("[data-top-bar]");
  const next = document.querySelector('[data-top-bar] .swiper-button-next');
  const prev = document.querySelector('[data-top-bar] .swiper-button-prev');
  if (!topBar) return

  const topBarSwiper = new Swiper(topBar.querySelector('.swiper'), {
    modules: [Autoplay, Navigation],
    slidesPerView: 1,
    spaceBetween: 0,
    watchOverflow: true,
    loop: true,
    speed: 1000,
    navigation: {
      nextEl: next,
      prevEl: prev,
      disabledClass: '-disabled',
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
  });

  // Autoplay
  topBarSwiper.autoplay.stop();
  const eventType = window.mobile ? 'scroll' : 'mousemove';
  window.addEventListener(eventType, topBarSwiper.autoplay.start, { once: true });

  const closeTopbar = document.querySelector('.close-topbar');
  const topMain = document.querySelector('.topbar-main');
  const searchMobile = document.querySelector('.header-search-mobile')
  if (closeTopbar) {
    closeTopbar.addEventListener('click', () => {
      topBar.classList.add('hide');
      searchMobile.classList.add('-on-top');
      topMain.classList.add('hide');
    });
  }
}